(function() {
  function initUrgencyBadges() {
    const container = document.querySelector('[data-urgency-badges]');
    if (!container) return;

    // 1. Live Visitor Fluctuator
    const visitorEl = container.querySelector('[data-visitor-count]');
    if (visitorEl) {
      let currentVisitors = Math.floor(Math.random() * (19 - 11 + 1)) + 11;
      visitorEl.textContent = currentVisitors;

      setInterval(function() {
        const delta = Math.floor(Math.random() * 5) - 2; // -2 to +2
        currentVisitors = Math.max(8, Math.min(24, currentVisitors + delta));
        visitorEl.textContent = currentVisitors;
      }, 5000);
    }

    // 2. Estimated Delivery Date Calculator
    const deliveryEl = container.querySelector('[data-delivery-date]');
    if (deliveryEl) {
      const now = new Date();
      const minDays = 2;
      const maxDays = 4;

      function addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }

      const minDate = addDays(now, minDays);
      const maxDate = addDays(now, maxDays);

      const monthsTr = [
        'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
        'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
      ];

      let deliveryStr = '';
      if (minDate.getMonth() === maxDate.getMonth()) {
        deliveryStr = minDate.getDate() + ' - ' + maxDate.getDate() + ' ' + monthsTr[minDate.getMonth()];
      } else {
        deliveryStr = minDate.getDate() + ' ' + monthsTr[minDate.getMonth()] + ' - ' + maxDate.getDate() + ' ' + monthsTr[maxDate.getMonth()];
      }

      deliveryEl.textContent = deliveryStr;
    }

    // 3. Variant Stock Updates
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        updateStockDisplay(e.detail.variant);
      }
    });

    function updateStockDisplay(variant) {
      const stockRow = container.querySelector('[data-stock-row]');
      const stockNum = container.querySelector('[data-stock-number]');
      const stockFill = container.querySelector('[data-stock-fill]');
      if (!stockRow || !stockNum || !stockFill) return;

      if (variant.available) {
        const qty = variant.inventory_quantity > 0 ? variant.inventory_quantity : 3;
        stockNum.textContent = qty;
        const percentage = Math.min(100, Math.max(15, qty * 10));
        stockFill.style.width = percentage + '%';
        stockRow.style.display = 'flex';
      } else {
        stockRow.style.display = 'none';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUrgencyBadges);
  } else {
    initUrgencyBadges();
  }
})();
